<template lang="html">
  <div class="teklif-form-container">
    <div class="header-section">
      <b-row>
        <b-col cols="11">
          <vs-card>
            <div style="margin: 15px">
              <b-row>
                <b-col cols="12">
                  <div class="card-header">
                    <h3 style="color: rgb(202, 0, 0); font-weight: bold">Teklif Formu</h3>
                    <b-button variant="outline-light">
                      <img
                        :src="require('@/assets/images/logo/FFlogo.png')"
                        alt="Logo"
                        class="logoFirm"
                        @click="getTeklifOnayListMusteri"
                      />
                    </b-button>
                  </div>
                </b-col>
                <b-col>
                  <div class="sender-details">
                    <h3 style="font-family: sans-serif">Türkiye'nin Ferforje Markası</h3>

                    <h3 style="color: rgb(202, 0, 0); font-weight: bold">
                      FATİH PROFİL SANAYİ VE TİCARET A.Ş.
                    </h3>
                    <b-row align-v="center" style="margin-top: 8px">
                      <b-col cols="3" align-self="center">
                        <b-form-group
                          :label="$t('address') + ':'"
                          label-for="h-first-name"
                          style="font-weight: bold; font-size: larger"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <h6 style="margin: 0px">
                          Organize Sanayi 1. Kısım Turan Bahadır Cad. No:15 Honaz/DENİZLİ
                        </h6>
                      </b-col>
                    </b-row>
                    <b-row align-v="center" style="margin-top: 8px">
                      <b-col cols="3" align-self="center">
                        <b-form-group
                          :label="$t('shipPhone') + ':'"
                          label-for="h-first-name"
                          style="font-weight: bold; font-size: larger"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <h6 style="margin: 0px">+90 258 269 16 64</h6>
                      </b-col>
                    </b-row>
                    <b-row align-v="center" style="margin-top: 8px">
                      <b-col cols="3" align-self="center">
                        <b-form-group
                          :label="$t('fax') + ':'"
                          label-for="h-first-name"
                          style="font-weight: bold; font-size: larger"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <h6 style="margin: 0px">+90 258 269 11 41</h6>
                      </b-col>
                    </b-row>
                    <b-row align-v="center" style="margin-top: 8px">
                      <b-col cols="3" align-self="center">
                        <b-form-group
                          :label="$t('Email') + ':'"
                          label-for="h-first-name"
                          style="font-weight: bold; font-size: larger"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <h6 style="margin: 0px">pazarlama@fatih.com.tr</h6>
                      </b-col>
                    </b-row>
                    <b-row align-v="center" style="margin-top: 8px">
                      <b-col cols="3" align-self="center">
                        <b-form-group
                          :label="$t('taxOffice') + ':'"
                          label-for="h-first-name"
                          style="font-weight: bold; font-size: larger"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <h6 style="margin: 0px">Saraylar Vergi Dairesi</h6>
                      </b-col>
                    </b-row>
                    <b-row align-v="center" style="margin-top: 8px">
                      <b-col cols="3" align-self="center">
                        <b-form-group
                          :label="$t('taxNumber') + ':'"
                          label-for="h-first-name"
                          style="font-weight: bold; font-size: larger"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <h6 style="margin: 0px">385 001 70 69</h6>
                      </b-col>
                    </b-row>
                  </div>
                </b-col>
                <b-col>
                  <div class="right-panel">
                    <b-row align-v="center" style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('date') + ':'"
                          label-for="h-first-name"
                          style="font-weight: bold; font-size: larger; text-align: end"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <h6 style="margin: 0px">{{ getDate() }}</h6>
                      </b-col>
                    </b-row>
                    <b-row align-v="center" style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('No') + ':'"
                          label-for="h-first-name"
                          style="font-weight: bold; font-size: larger; text-align: end"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <h6 v-if="isDone == 'true'" style="margin: 0px">
                          {{ offerNumberR }}
                        </h6>
                      </b-col>
                    </b-row>
                    <b-row style="margin-top: 8px">
                      <b-col cols="12">
                        <vs-input
                          size="small"
                          v-model="title"
                          class="w-full"
                          type="text"
                          name="title"
                          v-validate="'required'"
                        />
                        <span class="text-danger text-sm" v-show="errors.has('title')">{{
                          errors.first("title")
                        }}</span>
                      </b-col>
                    </b-row>
                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="'* ' + $t('shipName') + ':'"
                          label-for="h-first-name"
                          style="font-weight: bold; font-size: larger"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="4">
                        <vs-input
                          size="small"
                          v-model="shipName"
                          type="text"
                          name="title"
                          v-validate="'required'"
                          class="w-full"
                        />
                        <span class="text-danger text-sm" v-show="errors.has('title')">{{
                          errors.first("title")
                        }}</span>
                      </b-col>
                      <b-col cols="4">
                        <vs-input
                          size="small"
                          v-model="shipSurname"
                          type="text"
                          name="title"
                          v-validate="'required'"
                          class="w-full"
                        />
                        <span class="text-danger text-sm" v-show="errors.has('title')">{{
                          errors.first("title")
                        }}</span>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="'* ' + $t('invoiceAddress') + ':'"
                          label-for="h-first-name"
                          style="font-weight: bold; font-size: larger"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="invoiceAddress"
                          type="text"
                          name="invoiceAddress"
                          v-validate="'required'"
                          class="w-full"
                        />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('invoiceAddress')"
                          >{{ errors.first("invoiceAddress") }}</span
                        >
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="'* ' + $t('shipPhone') + ':'"
                          label-for="h-first-name"
                          style="font-weight: bold; font-size: larger"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="shipPhone"
                          type="text"
                          name="shipPhone"
                          v-validate="'required'"
                          class="w-full"
                        />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('shipPhone')"
                          >{{ errors.first("shipPhone") }}</span
                        >
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="'* ' + $t('fax') + ':'"
                          label-for="h-first-name"
                          style="font-weight: bold; font-size: larger"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="fax"
                          type="text"
                          name="fax"
                          v-validate="'required'"
                          class="w-full"
                        />
                        <span class="text-danger text-sm" v-show="errors.has('fax')">{{
                          errors.first("fax")
                        }}</span>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="'* ' + $t('eMail') + ':'"
                          label-for="h-first-name"
                          style="font-weight: bold; font-size: larger"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="eMail"
                          type="text"
                          name="eMail"
                          v-validate="'required|email'"
                          class="w-full"
                        />
                        <span class="text-danger text-sm" v-show="errors.has('eMail')">{{
                          errors.first("eMail")
                        }}</span>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="'* ' + $t('taxOffice') + ':'"
                          label-for="h-first-name"
                          style="font-weight: bold; font-size: larger"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="taxOffice"
                          type="text"
                          name="taxOffice"
                          v-validate="'required'"
                        />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('taxOffice')"
                          >{{ errors.first("taxOffice") }}</span
                        >
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="'* ' + $t('taxNumber') + ':'"
                          label-for="h-first-name"
                          style="font-weight: bold; font-size: larger"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="taxNumber"
                          type="text"
                          name="taxNumber"
                          v-validate="'required'"
                        />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('taxNumber')"
                          >{{ errors.first("taxNumber") }}</span
                        >
                      </b-col>
                    </b-row>
                  </div>
                </b-col>
              </b-row>
              <vs-table stripe :data="cartItemsLocal" style="margin-top: 15px">
                <template slot="header"> </template>

                <template slot="thead">
                  <vs-th style="color: black; font-weight: bold">
                    {{ $t("Image") }}
                  </vs-th>
                  <vs-th style="color: black; font-weight: bold">
                    {{ $t("StockCode") }}
                  </vs-th>

                  <vs-th style="color: black; font-weight: bold">
                    {{ $t("size") }}
                  </vs-th>
                  <vs-th style="color: black; font-weight: bold">
                    {{ $t("Weight") }}
                  </vs-th>

                  <vs-th style="color: black; font-weight: bold">
                    {{ $t("Description") }}
                  </vs-th>
                  <vs-th style="color: black; font-weight: bold">
                    {{ $t("Quantity") }}
                  </vs-th>

                  <vs-th style="color: black; font-weight: bold">
                    {{ $t("Price") }}
                  </vs-th>
                  <vs-th style="color: black; font-weight: bold">
                    {{ $t("discount") }}
                  </vs-th>

                  <vs-th style="color: black; font-weight: bold">
                    {{ $t("sum") }}
                  </vs-th>
                  <vs-th style="color: black; font-weight: bold">
                    {{ $t("deadline") }}
                  </vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td style="color: black; font-weight: bold">
                      <img
                        :src="tr.imageUrl"
                        alt="Product Image"
                        style="max-width: 75px; max-height: 150px"
                      />
                    </vs-td>
                    <vs-td :data="tr.stockCode" style="color: black; font-weight: bold">
                      {{ tr.stockCode }}
                    </vs-td>

                    <vs-td :data="tr.stockWidth" style="color: black; font-weight: bold">
                      {{ tr.stockLength ? tr.stockLength.replace("cm", "") + " x " : "" }}
                      {{ tr.stockWidth ? tr.stockWidth : "" }}
                    </vs-td>
                    <vs-td :data="tr.stockWidth" style="color: black; font-weight: bold">
                      {{
                        isNaN(tr.stockWeight)
                          ? 0
                          : Intl.NumberFormat().format(tr.stockWeight)
                      }}
                    </vs-td>
                    <vs-td :data="tr.description" style="color: black; font-weight: bold">
                      <vs-textarea
                        size="small"
                        v-model="tr.description"
                        type="text"
                        style="width: 150px"
                      />
                    </vs-td>
                    <vs-td
                      :data="tr.quantityLine"
                      style="color: black; font-weight: bold"
                    >
                      <b-row>
                        <div
                          v-if="parseInt(tr.quantityLine) > parseInt(tr.stockQuantity)"
                        >
                          <vs-chip
                            color="danger"
                            v-b-tooltip.hover.bottom="
                              new Intl.NumberFormat().format(parseInt(tr.stockQuantity)) +
                              ' adet'
                            "
                          >
                            {{ $t("preOrder") }}
                          </vs-chip>
                        </div>
                        <div v-else>
                          <vs-chip
                            color="success"
                            v-b-tooltip.hover.bottom="
                              new Intl.NumberFormat().format(parseInt(tr.stockQuantity)) +
                              ' adet'
                            "
                          >
                            {{ $t("prepare") }}
                          </vs-chip>
                        </div>
                      </b-row>

                      <vs-input
                        size="small"
                        v-model="tr.quantityLine"
                        type="text"
                        style="
                          font-size: inherit;
                          color: black;
                          font-weight: bold;
                          width: 75px;
                        "
                        :name="'quantity_' + indextr"
                        v-validate="'required'"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('quantity_' + indextr)"
                        >{{ errors.first("quantity_" + indextr) }}</span
                      >
                    </vs-td>

                    <vs-td
                      :data="data[indextr].priceLine"
                      style="color: black; font-weight: bold"
                    >
                      {{ tr.currency }} {{ tr.currCode }}
                      <vs-input
                        v-if="localCurrency == 'TRY'"
                        style="
                          font-size: inherit;
                          color: black;
                          font-weight: bold;
                          width: 75px;
                        "
                        size="small"
                        v-model="data[indextr].priceLine"
                        type="text"
                        :name="'price_' + indextr"
                        v-validate="'required'"
                      />
                      <vs-input
                        v-else-if="localCurrency == 'USD'"
                        style="
                          font-size: inherit;
                          color: black;
                          font-weight: bold;
                          width: 75px;
                        "
                        size="small"
                        v-model="data[indextr].priceLineUSD"
                        type="text"
                        :name="'price_' + indextr"
                        v-validate="'required'"
                      />
                      <vs-input
                        v-else-if="localCurrency == 'EUR'"
                        style="
                          font-size: inherit;
                          color: black;
                          font-weight: bold;
                          width: 75px;
                        "
                        size="small"
                        v-model="data[indextr].priceLineEUR"
                        type="text"
                        :name="'price_' + indextr"
                        v-validate="'required'"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('price_' + indextr)"
                        >{{ errors.first("price_" + indextr) }}</span
                      >
                    </vs-td>
                    <vs-td
                      :data="data[indextr].discountRateLine"
                      style="color: black; font-weight: bold"
                    >
                      <vs-input
                        style="
                          font-size: inherit;
                          color: black;
                          font-weight: bold;
                          width: 75px;
                        "
                        size="small"
                        v-model="data[indextr].discountRateLine"
                        type="text"
                        :name="'discount_' + indextr"
                        v-validate="'required'"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('discount_' + indextr)"
                        >{{ errors.first("discount_" + indextr) }}</span
                      >
                    </vs-td>
                    <vs-td>
                      <div>
                        <p v-if="localCurrency == 'TRY'">
                          {{
                            new Intl.NumberFormat("tr-TR", {
                              style: "currency",
                              currency: "TRY",
                            }).format(parseFloat(tutarForItem(tr)))
                          }}
                        </p>
                        <p v-if="localCurrency == 'USD'">
                          {{
                            new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                            }).format(parseFloat(tutarForItem(tr)))
                          }}
                        </p>
                        <p v-if="localCurrency == 'EUR'">
                          {{
                            new Intl.NumberFormat("de-DE", {
                              style: "currency",
                              currency: "EUR",
                            }).format(parseFloat(tutarForItem(tr)))
                          }}
                        </p>
                      </div>
                    </vs-td>
                    <vs-td>
                      <div>
                        <b-form-datepicker
                          id="baslangic"
                          v-model="data[indextr].deadline"
                          size="sm"
                          placeholder="-"
                          style="width: 200px"
                          :date-format-options="{
                            year: 'numeric',
                            month: 'numeric',
                            day: 'numeric',
                          }"
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <b-row style="margin-top: 15px">
                <b-col cols="5">
                  <b-row>
                    <b-col cols="5" align-self="center">
                      <b-form-group
                        :label="'* ' + $t('validFor') + ':'"
                        label-for="h-first-name"
                        style="font-weight: bold; font-size: larger"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="7">
                      <vs-input
                        size="small"
                        v-model="validityDuration"
                        type="number"
                        name="validFor"
                        v-validate="'required'"
                      />
                      <span class="text-danger text-sm" v-show="errors.has('validFor')">{{
                        errors.first("validFor")
                      }}</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="5" align-self="center">
                      <b-form-group
                        :label="'* ' + $t('shipDate') + ':'"
                        label-for="h-first-name"
                        style="font-weight: bold; font-size: larger"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="7">
                      <b-form-datepicker
                        id="baslangic"
                        v-model="shipDate"
                        size="sm"
                        placeholder="-"
                        name="shipDate"
                        v-validate="'required'"
                        style="width: 200px"
                        :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                      />
                      <span class="text-danger text-sm" v-show="errors.has('shipDate')">{{
                        errors.first("shipDate")
                      }}</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="5" align-self="center">
                      <b-form-group
                        :label="'* ' + $t('transportType') + ':'"
                        label-for="h-first-name"
                        style="font-weight: bold; font-size: larger"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="7">
                      <vs-input
                        size="small"
                        v-model="transportType"
                        type="text"
                        name="transportType"
                        v-validate="'required'"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('transportType')"
                        >{{ errors.first("transportType") }}</span
                      >
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="5" align-self="center">
                      <b-form-group
                        :label="'* ' + $t('paymentType') + ':'"
                        label-for="h-first-name"
                        style="font-weight: bold; font-size: larger"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="7">
                      <vs-input
                        size="small"
                        v-model="paymentType"
                        type="text"
                        name="paymentType"
                        v-validate="'required'"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('paymentType')"
                        >{{ errors.first("paymentType") }}</span
                      >
                    </b-col>
                  </b-row>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col cols="5" align-self="center">
                      <b-form-group
                        :label="$t('pivotColumnGroupTotals') + $t('Weight') + ':'"
                        label-for="h-first-name"
                        style="font-weight: bold; font-size: larger"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="7">
                      <h4>{{ ttweight }} kg</h4>
                    </b-col>
                    <b-col> </b-col>
                  </b-row>
                  <vs-divider style="margin-bottom: 5px; margin-top: 5px"></vs-divider>
                  <b-row>
                    <b-col>
                      {{ $t("shipAddress") }}
                    </b-col>
                  </b-row>
                  <b-row>
                    <vs-textarea
                      size="small"
                      v-model="shipAddress"
                      type="text"
                      name="shipAddress"
                      v-validate="'required'"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('shipAddress')"
                      >{{ errors.first("shipAddress") }}</span
                    >
                  </b-row>
                </b-col>
                <b-col cols="4">
                  <b-row align-h="end">
                    <b-col cols="3" align-self="center">
                      <b-form-group
                        label-for="h-first-name"
                        style="font-weight: bold; font-size: larger"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="7">
                      <h5 v-if="localCurrency == 'TRY'">
                        {{
                          new Intl.NumberFormat("tr-TR", {
                            style: "currency",
                            currency: "TRY",
                          }).format(parseFloat(calculatedToplam))
                        }}
                      </h5>
                      <h5 v-if="localCurrency == 'USD'">
                        {{
                          new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                          }).format(parseFloat(calculatedToplam))
                        }}
                      </h5>
                      <h5 v-if="localCurrency == 'EUR'">
                        {{
                          new Intl.NumberFormat("de-DE", {
                            style: "currency",
                            currency: "EUR",
                          }).format(parseFloat(calculatedToplam))
                        }}
                      </h5>
                      <vs-divider></vs-divider>
                    </b-col>
                  </b-row>

                  <b-row align-h="end">
                    <b-col cols="3" align-self="start">
                      <b-form-group
                        :label="'* ' + $t('Vat') + ':'"
                        label-for="h-first-name"
                        style="font-weight: bold; font-size: larger"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="7">
                      <h5 v-if="localCurrency == 'TRY'">
                        {{
                          new Intl.NumberFormat("tr-TR", {
                            style: "currency",
                            currency: "TRY",
                          }).format(parseFloat(kdvUygulanmisGenelToplam))
                        }}
                      </h5>
                      <h5 v-if="localCurrency == 'USD'">
                        {{
                          new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                          }).format(parseFloat(kdvUygulanmisGenelToplam))
                        }}
                      </h5>
                      <h5 v-if="localCurrency == 'EUR'">
                        {{
                          new Intl.NumberFormat("de-DE", {
                            style: "currency",
                            currency: "EUR",
                          }).format(parseFloat(kdvUygulanmisGenelToplam))
                        }}
                      </h5>
                      <vs-divider></vs-divider>
                    </b-col>
                  </b-row>
                  <b-row align-h="end">
                    <b-col cols="3" align-self="start">
                      <b-form-group
                        :label="'* ' + $t('Discount') + ':'"
                        label-for="h-first-name"
                        style="font-weight: bold; font-size: larger"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="7">
                      <vs-input
                        size="small"
                        v-model="totalDiscountRate"
                        type="text"
                        name="totalDiscountRate"
                        v-validate="'required'"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('totalDiscountRate')"
                        >{{ errors.first("totalDiscountRate") }}</span
                      >
                      <vs-divider></vs-divider>
                    </b-col>
                  </b-row>
                  <b-row align-h="end">
                    <b-col cols="3" align-self="start">
                      <b-form-group
                        :label="'* ' + $t('sum') + ':'"
                        label-for="h-first-name"
                        style="font-weight: bold; font-size: larger"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="7">
                      <h5 v-if="localCurrency == 'TRY'">
                        {{
                          new Intl.NumberFormat("tr-TR", {
                            style: "currency",
                            currency: "TRY",
                          }).format(parseFloat(totalGenelToplam))
                        }}
                      </h5>
                      <h5 v-if="localCurrency == 'USD'">
                        {{
                          new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                          }).format(parseFloat(totalGenelToplam))
                        }}
                      </h5>
                      <h5 v-if="localCurrency == 'EUR'">
                        {{
                          new Intl.NumberFormat("de-DE", {
                            style: "currency",
                            currency: "EUR",
                          }).format(parseFloat(totalGenelToplam))
                        }}
                      </h5>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <div class="not-panel" style="margin-top: 15px">
                <h6>{{ $t("note1") }}</h6>
                <h6>{{ $t("note2") }}</h6>
                <h6>{{ $t("note3") }}</h6>

                <div style="display: flex; align-items: center">
                  <h6>Not4:</h6>
                  <vs-input
                    type="text"
                    class="styled-input"
                    size="small"
                    v-model="note1"
                    style="color: rgb(185, 0, 0); font-weight: bold; width: 650px"
                  />
                </div>

                <div style="display: flex; align-items: center">
                  <h6>Not5:</h6>
                  <vs-input
                    size="small"
                    type="text"
                    class="styled-input"
                    v-model="note2"
                    style="color: black; font-weight: bold; width: 650px"
                  />
                </div>
              </div>

              <table
                border="1"
                style="border-top: 1px solid; margin-top: 15px"
                class="border-collapse"
              >
                <tr>
                  <td>
                    <table style="text-align: center">
                      <tr>
                        <td style="padding: 8px; border: 1px solid; font-weight: 600">
                          {{ $t("info1") }}
                        </td>

                        <td style="padding: 8px; border: 1px solid">
                          {{ $t("info2") }}
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 8px; border: 1px solid">
                          {{ $t("info3") }}
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <br />
                <tr style="width: 100%">
                  <td>
                    <table style="text-align: center; width: 100%">
                      <tr>
                        <td style="padding: 8px; border: 1px solid; font-weight: 600">
                          {{ $t("prepared") }}
                        </td>

                        <td style="padding: 8px; border: 1px solid">Zeki KARADAĞ</td>
                        <td style="padding: 8px; border: 1px solid; font-weight: 600">
                          {{ $t("approver") }}
                        </td>
                        <td style="padding: 8px; border: 1px solid">Zeki KARADAĞ</td>

                        <td style="padding: 8px; border: 1px solid; font-weight: 600">
                          {{ $t("approverCust") }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            padding: 8px;
                            border: 1px solid;
                            height: 75px;
                            text-align: center;
                          "
                          colspan="2"
                        >
                          <p style="margin-top: -33px">{{ $t("signature") }}</p>
                        </td>
                        <td
                          style="
                            padding: 8px;
                            border: 1px solid;
                            height: 75px;
                            text-align: center;
                          "
                          colspan="2"
                        >
                          <p style="margin-top: -33px">{{ $t("signature") }}</p>
                        </td>
                        <td
                          style="
                            padding: 8px;
                            border: 1px solid;
                            height: 75px;
                            text-align: center;
                          "
                          colspan="2"
                        >
                          <p style="margin-top: -33px">{{ $t("signature") }}</p>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>

              <div class="button-container" style="margin-top: 15px">
                <vs-button
                  style="border-radius: 5px"
                  type="gradient"
                  color="primary"
                  @click="teklifYazdir()"
                >
                  {{ $t("print") }}</vs-button
                >
                <vs-button
                  v-if="ordStatus == 0"
                  style="border-radius: 5px"
                  type="gradient"
                  color="success"
                  @click="teklifKaydet()"
                >
                  {{ $t("updateQuote") }}
                </vs-button>
                <vs-button
                  v-if="ordStatus == 0"
                  style="border-radius: 5px"
                  type="gradient"
                  color="danger"
                  @click="teklifGonder()"
                  >{{ $t("approveQuote") }}</vs-button
                >
              </div>
            </div>
            <vs-card v-if="ordStatus == 1" class="bg-success" style="text-align: center">
              <b-row>
                <b-col>
                  <h3 style="color: white">Teklif Onaylanmıştır</h3>
                </b-col>
              </b-row>
            </vs-card>
          </vs-card>
        </b-col>
        <b-col>
          <i18n />
        </b-col>
      </b-row>

      <TeklifOnayMail ref="teklifOnayMailRef" />
      <teklifYazdir
        ref="teklifYazdir"
        :cartItems="cartItemsLocal"
        :offerItems="offerItemLocalForPrint"
        :localCurrency="localCurrency"
        :totalDiscountRate="totalDiscountRate"
        :calculatedToplam="calculatedToplam"
        :totalGenelToplam="totalGenelToplam"
        :kdvUygulanmisGenelToplam="kdvUygulanmisGenelToplam"
        :ttweight="ttweight"
        :validityDuration="validityDuration"
        :shipDate="shipDate"
        :paymentType="paymentType"
        :transportType="transportType"
        :isDone="isDone"
      />
    </div>
  </div>
</template>

<script>
import teklifYazdir from "./pages/components/teklifYazdir.vue";
import TeklifOnayMail from "./TeklifOnayMail.vue";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import { Validator } from "vee-validate";
import I18n from "../../layouts/components/navbar/components/I18n.vue";

export default {
  components: {
    I18n,
    teklifYazdir,
    Datepicker,
    TeklifOnayMail,
  },
  data() {
    return {
      offerItemLocalForPrint: {},
      ordStatus: 0,
      localCurrency: "",
      calculatedToplam: "",
      offerNumberR: "",
      isDone: "",
      note1: "",
      note2: "",
      cartItemsLocal: [],
      offerNumber: "",
      totalDiscountRate: 0,
      shipDate: "",
      paymentType: "Peşin",
      fax: "",
      title: "",
      shipName: "",
      eMail: "",
      taxNumber: "",
      taxOffice: "",
      invoiceAddress: "",
      shipAddress: "",
      shipPhone: "",
      shipSurname: "",
      description: "",
      taxOffice: "",
      validityDuration: 1, // Default değeri burada 1 olarak ayarlanmıştır
      transportType: "Nakliye DAHİL",
      paymentType: "PEŞİN",
      discountRateLine: 0,
      tutar: 0,
      kdvOrani: 20, // %20 KDV oranı
      genelToplamInput: 0,
    };
  },
  methods: {
    getTeklifOnayListMusteri() {
      const url = this.$router.resolve({
        path: `/`,
      }).href;
      window.open(url, "_blank");
    },
    sortByStockCode(items) {
      return items.sort((a, b) => {
        const stockCodeA = a.stockCode.toUpperCase(); // Büyük/küçük harf duyarlı sıralama
        const stockCodeB = b.stockCode.toUpperCase();

        if (stockCodeA < stockCodeB) {
          return -1;
        }
        if (stockCodeA > stockCodeB) {
          return 1;
        }
        return 0;
      });
    },
    setCartItems(index, tr) {
      var vm = this;
      const vs = this.$vs;
      let currPrice, currencyCurr;
      if (vm.localCurrency == "TRY") {
        currPrice = tr.priceLine;
      } else if (vm.localCurrency == "USD") {
        currPrice = tr.priceLineUSD;
      } else if (vm.localCurrency == "EUR") {
        currPrice = tr.priceLineEUR;
      }

      let args = {
        offerNumber: vm.offerNumberR,
        isDue: "insert",
        barcode: tr.stockCode,
        eMail: vm.eMail,
        shipPhone: vm.shipPhone,
        title: vm.title,

        shipName: vm.shipName,
        shipSurname: vm.shipSurname,
        orderStatus: "0",
        shipAddress: vm.shipAddress,
        shipCityCode: "",
        shipDistrictCode: "",
        invoiceAddress: vm.invoiceAddress,
        taxOffice: vm.taxOffice,
        taxNumber: vm.taxNumber,
        deadline: tr.deadline,
        description: tr.description,
        validityDuration: vm.validityDuration,
        shipDate: vm.shipDate,
        transportType: vm.transportType,
        paymentType: vm.paymentType,
        quantityLine: tr.quantityLine,
        priceLine: tr.priceLine,
        discountRateLine: tr.discountRateLine,
        currPrice: currPrice,
        currency: tr.currency,
        currCode: tr.currCode,
        vatRateLine: "20",
        totalDiscountRate: vm.totalDiscountRate,
        fax: vm.fax,
        note1: vm.note1,
        note2: vm.note2,
      };
      /*
      vm.$store.dispatch('GetCrudToOfferList', args)
        .then((response) => { 
        })
        .catch((error) => {
          vs.notify({
            text: error,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-center"
          });
          console.error('Error', error);
        });
*/
    },
    setInputOffer() {
      if (this.$route.params.onay == "false") {
        this.offerItemLocalForPrint = {
          shipDate: this.shipDate,
          paymentType: this.paymentType,
          description: this.description,
          validityDuration: this.validityDuration,
          transportType: this.transportType,
          paymentType: this.paymentType,
          shipName: this.shipName,
          shipSurname: this.shipSurname,
          eMail: this.eMail,
          invoiceAddress: this.invoiceAddress,
          taxOffice: this.taxOffice,
          fax: this.fax,
          shipAddress: this.shipAddress,
          shipPhone: this.shipPhone,
          taxNumber: this.taxNumber,
          totalDiscountRate: this.totalDiscountRate,
          title: this.title,
          note1: this.note1,
          note2: this.note2,
        };

        let offerItemLocal = {
          shipDate: this.shipDate,
          paymentType: this.paymentType,
          description: this.description,
          validityDuration: this.validityDuration,
          transportType: this.transportType,
          paymentType: this.paymentType,
          shipName: this.shipName,
          shipSurname: this.shipSurname,
          eMail: this.eMail,
          invoiceAddress: this.invoiceAddress,
          taxOffice: this.taxOffice,
          fax: this.fax,
          shipAddress: this.shipAddress,
          shipPhone: this.shipPhone,
          taxNumber: this.taxNumber,
          totalDiscountRate: this.totalDiscountRate,
          title: this.title,
          note1: this.note1,
          note2: this.note2,
        };
        this.$store.commit("offerItem", offerItemLocal);
      }
    },
    getDate() {
      return moment(String(Date())).format("DD.MM.YYYY");
    },
    updateIskonto(indextr, event) {
      this.$store.commit("setDiscountRateLine", {
        index: indextr,
        value: parseFloat(event.target.value.replace(",", ".")) || 0,
      });
    },
    tutarForItem(item) {
      if (item && item.priceLine && item.quantityLine) {
        let priceLine = 0.0;
        if (this.localCurrency == "TRY") {
          priceLine = parseFloat(item.priceLine.toString().replace(",", "."));
        } else if (this.localCurrency == "EUR")
          priceLine = parseFloat(item.priceLineEUR.toString().replace(",", "."));
        else if (this.localCurrency == "USD")
          priceLine = parseFloat(item.priceLineUSD.toString().replace(",", "."));

        const quantity = parseInt(item.quantityLine);
        let discountedPrice = priceLine;
        if (item.discountRateLine != 0) {
          const discountRate = parseInt(item.discountRateLine);
          // Calculate the discounted price
          discountedPrice = priceLine - (priceLine * discountRate) / 100;
        }
        item["totalRowPrice"] = discountedPrice * quantity;
        //  this.setCartItems(0, item)
        this.calculatedToplam = this.cartItemsLocal.reduce((total, item, index) => {
          return total + item.totalRowPrice;
        }, 0);
        return discountedPrice * quantity;
      }
      return 0;
    },

    teklifYazdir() {
      this.$refs.teklifYazdir.yazdir();
    },
    teklifGonder() {
      var vm = this;
      const vs = this.$vs;
      let uptArgs = {
        isDue: "update",
        offerNumber: vm.offerNumberR,
      };
      vm.$store.dispatch("GetCrudToOfferList", uptArgs).then((response) => {
        if (response.veriler.response == "Yes") {
          vs.notify({
            text: "Teklif onaylandı.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
            position: "top-center",
          });
        }
      });
    },
    saveOffer(index, offerNumber) {
      var vm = this;
      const vs = this.$vs;
      let currPrice, currencyCurr;
      if (vm.localCurrency == "TRY") {
        currPrice = vm.cartItemsLocal[index].priceLine;
      } else if (vm.localCurrency == "USD") {
        currPrice = vm.cartItemsLocal[index].priceLineUSD;
      } else if (vm.localCurrency == "EUR") {
        currPrice = vm.cartItemsLocal[index].priceLineEUR;
      }

      let args = {
        offerNumber: offerNumber.replace(/"/g, ""),
        isDue: "insert",
        barcode: vm.cartItemsLocal[index].stockCode,
        eMail: vm.eMail,
        shipPhone: vm.shipPhone,
        title: vm.title,

        shipName: vm.shipName,
        shipSurname: vm.shipSurname,
        orderStatus: "0",
        shipAddress: vm.shipAddress,
        shipCityCode: "",
        shipDistrictCode: "",
        invoiceAddress: vm.invoiceAddress,
        taxOffice: vm.taxOffice,
        taxNumber: vm.taxNumber,
        deadline: vm.cartItemsLocal[index].deadline,
        description: vm.cartItemsLocal[index].description,
        validityDuration: vm.validityDuration,
        shipDate: vm.shipDate,
        transportType: vm.transportType,
        paymentType: vm.paymentType,
        quantityLine: vm.cartItemsLocal[index].quantityLine,
        priceLine: vm.cartItemsLocal[index].priceLine,
        discountRateLine: vm.cartItemsLocal[index].discountRateLine,
        currPrice: currPrice,
        currency: vm.cartItemsLocal[index].currency,
        currCode: vm.cartItemsLocal[index].currCode,
        vatRateLine: "20",
        totalDiscountRate: vm.totalDiscountRate,
        fax: vm.fax,
        note1: vm.note1,
        note2: vm.note2,
      };

      vm.$store
        .dispatch("GetCrudToOfferList", args)
        .then((response) => {
          if (index == 0) {
            vs.notify({
              text: "Teklif kaydı yapıldı.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
            /* 
            
             vm.$refs.teklifOnayMailRef.getItems(offerNumber.replace(/"/g, ""), args);
             setTimeout(function () {
               const argsMail = {
                 receiver: "rukiye@uzum.com.tr, evrim@uzum.com.tr, " + vm.offerItem.eMail,
                 message: vm.$refs.teklifOnayMailRef.$el.innerHTML,
                 subject: "Teklif Onay İşlemi"
               };
               vm.$store.dispatch('sendMail', argsMail)
                 .then((response) => {
                   
                 })
             }, 2000);*/
          } else {
            index--;
            vm.saveOffer(index, offerNumber);
          }
        })
        .catch((error) => {
          vs.notify({
            text: error,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-center",
          });
          console.error("Error", error);
        });
    },
    teklifKaydet() {
      this.saveOffer(this.cartItemsLocal.length - 1, this.offerNumberR);
    },
  },

  created() {
    /* try {
 
       this.$store
         .dispatch("fetchExchangeRates")
         .then(response => {
           console.log(response)
         });
     } catch (error) {
       console.log(error)
     }*/
    if (this.$route.params.onay == "true") {
      this.offerNumberR = this.$route.params.offerNumber.replace(/"/g, "");
      let args = {
        offerNumber: this.$route.params.offerNumber.replace(/"/g, ""),
        isDue: "detail",
      };
      this.$store.dispatch("GetCrudToOfferList", args).then((response) => {
        let offerDetailList = response.veriler;
        this.cartItemsLocal = response.veriler[0].Details;
        let currArr = offerDetailList[0].Details[0].currCode;
        if (currArr == "EUR") {
          this.localCurrency = "EUR";
          this.$i18n.locale = "en";
          localStorage.setItem("userLanguage", "en");
        } else if (currArr == "TRY") {
          this.$i18n.locale = "tr";
          localStorage.setItem("userLanguage", "tr");
          this.localCurrency = "TRY";
        } else {
          this.localCurrency = "USD";
          this.$i18n.locale = "en";
          localStorage.setItem("userLanguage", "en");
        }
        this.locale = this.$i18n.locale;
        this.shipDate = moment(String(offerDetailList[0].shipDate)).format("YYYY-MM-DD");
        this.paymentType = offerDetailList[0].paymentType;
        this.shipName = offerDetailList[0].shipName;
        this.shipSurname = offerDetailList[0].shipSurname;
        this.ordStatus = offerDetailList[0].ordStatus;

        this.eMail = offerDetailList[0].eMail;
        this.taxNumber = offerDetailList[0].taxNumber;
        this.shipPhone = offerDetailList[0].shipPhone;

        this.shipAddress = offerDetailList[0].shipAddress;
        this.invoiceAddress = offerDetailList[0].invoiceAddress;
        this.title = offerDetailList[0].title;

        this.note1 = offerDetailList[0].note1;
        this.note2 = offerDetailList[0].note2;
        this.description = "";
        this.taxOffice = offerDetailList[0].taxOffice;
        this.validityDuration = offerDetailList[0].validityDuration; // Default değeri burada 1 olarak ayarlanmıştır
        this.totalDiscountRate =
          offerDetailList[0].totalDiscountRate == "" ||
          typeof offerDetailList[0].totalDiscountRate == "undefined"
            ? 0
            : offerDetailList[0].totalDiscountRate;
        this.transportType = offerDetailList[0].transportType;
        this.paymentType = offerDetailList[0].paymentType;
        this.fax = offerDetailList[0].fax;

        this.offerItemLocalForPrint = {
          shipDate: this.shipDate,
          paymentType: this.paymentType,
          description: this.description,
          validityDuration: this.validityDuration,
          transportType: this.transportType,
          paymentType: this.paymentType,
          shipName: this.shipName,
          shipSurname: this.shipSurname,
          eMail: this.eMail,
          invoiceAddress: this.invoiceAddress,
          taxOffice: this.taxOffice,
          fax: this.fax,
          shipAddress: this.shipAddress,
          shipPhone: this.shipPhone,
          taxNumber: this.taxNumber,
          totalDiscountRate: this.totalDiscountRate,
          title: this.title,
          note1: this.note1,
          note2: this.note2,
        };
      });
    }

    const dict = {
      custom: {
        valid: {
          required: this.$t("valid"),
        },
        title: {
          required: this.$t("requireTitle"),
        },
        shipName: {
          required: this.$t("requireName"),
        },
        shipSurname: {
          required: this.$t("requireSurname"),
        },
        eMail: {
          required: this.$t("requireMail"),
        },
        shipAddress: {
          required: this.$t("requireShipaddress"),
        },
        shipPhone: {
          required: this.$t("requireshipPhone"),
        },
        taxNumber: {
          required: this.$t("requiretaxNumber"),
        },
        taxOffice: {
          required: this.$t("requiretaxOffice"),
        },
        fax: {
          required: this.$t("requirefax"),
        },
      },
    };

    Validator.localize("en", dict);
  },

  computed: {
    isInCart() {
      return (itemId) => this.$store.getters["eCommerce/isInCart"](itemId);
    },
    offerItem: {
      get() {
        return this.$store.state.offerItem;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },

    quantityLine() {
      const totalQuantity = this.cartItemsLocal.reduce(
        (total, item) => total + parseInt(item.quantityLine),
        0
      );
      return totalQuantity;
    },
    cartItems: {
      get() {
        return this.$store.state.eCommerce.cartItems;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },

    kdvUygulanmisGenelToplam() {
      const kdvOraniDecimal = 20 / 100; // Use the fixed VAT rate of 20%
      const kdvliToplam = this.calculatedToplam * kdvOraniDecimal;
      return kdvliToplam;
    },
    totalGenelToplam() {
      const totalDiscountRateDec =
        (parseFloat(this.kdvUygulanmisGenelToplam) + parseFloat(this.calculatedToplam)) *
        (parseInt(this.totalDiscountRate) / 100);

      // Calculate totalGenelToplam by summing kdvUygulanmisGenelToplam and calculatedToplam
      const totalAfterDiscount =
        parseFloat(this.kdvUygulanmisGenelToplam) +
        parseFloat(this.calculatedToplam) -
        totalDiscountRateDec;
      return isNaN(totalAfterDiscount) ? 0 : totalAfterDiscount;
    },

    ttweight() {
      const tweight = this.cartItemsLocal.reduce(
        (total, item) =>
          total +
          parseFloat(isNaN(item.stockWeight) ? 0 : item.stockWeight) * item.quantityLine,
        0
      );
      return Intl.NumberFormat().format(tweight);
    },
  },
  mounted() {
    this.isDone = this.$route.params.onay;
    if (this.cartItems.length > 0) {
      this.cartItemsLocal = this.cartItems;
    }
    if (this.isDone == "false") {
      this.shipDate = this.offerItem.shipDate;
      this.paymentType = this.offerItem.paymentType;
      this.shipName = this.offerItem.shipName;
      this.shipSurname = this.offerItem.shipSurname;

      this.eMail = this.offerItem.eMail;
      this.taxNumber = this.offerItem.taxNumber;
      this.shipPhone = this.offerItem.shipPhone;
      this.shipAddress = this.offerItem.shipAddress;
      this.invoiceAddress = this.offerItem.invoiceAddress;
      this.title = this.offerItem.title;

      this.note1 = this.offerItem.note1;
      this.note2 = this.offerItem.note2;
      this.description = "";
      this.taxOffice = this.offerItem.taxOffice;
      this.validityDuration = this.offerItem.validityDuration; // Default değeri burada 1 olarak ayarlanmıştır
      this.totalDiscountRate =
        this.offerItem.totalDiscountRate == "" ||
        typeof this.offerItem.totalDiscountRate == "undefined"
          ? 0
          : this.offerItem.totalDiscountRate;
      this.transportType = this.offerItem.transportType;
      this.paymentType = this.offerItem.paymentType;
      this.fax = this.offerItem.fax;

      this.offerItemLocalForPrint = {
        shipDate: this.shipDate,
        paymentType: this.paymentType,
        description: this.description,
        validityDuration: this.validityDuration,
        transportType: this.transportType,
        paymentType: this.paymentType,
        shipName: this.shipName,
        shipSurname: this.shipSurname,
        eMail: this.eMail,
        invoiceAddress: this.invoiceAddress,
        taxOffice: this.taxOffice,
        fax: this.fax,
        shipAddress: this.shipAddress,
        shipPhone: this.shipPhone,
        taxNumber: this.taxNumber,
        totalDiscountRate: this.totalDiscountRate,
        title: this.title,
        note1: this.note1,
        note2: this.note2,
      };
    }
  },
  watch: {
    calculatedToplam(val) {
      return val;
    },
    offerItem(val) {
      return val;
    },
    cartItems(val) {
      return val;
    },
  },
};
</script>
<style scoped>
[dir] .vs-con-table .vs-con-tbody {
  min-height: 750px;
}

/* Initially hide the component */
.teklifYazdir {
  display: none;
}

body {
  background-color: #ffffff;
  /* Set the desired color */
}

/* Display the component when in print mode */
@media print {
  .teklifYazdir {
    display: block !important;
  }
}
</style>
